import type { ReactNode } from 'react';
import { ErrorBoundary } from '../components/feedback/ErrorBoundary';
import { ThemeProvider } from '../providers/ThemeProvider';
import { AuthProvider } from '../providers/AuthProvider';
import { CompanyProvider } from '../providers/CompanyProvider';
import { IdentityProvider } from '../providers/IdentityProvider';
import { ToastProvider } from '../ui';

// Provider composition root. Order matters: theme → auth (session) → company (cold-start
// discovery/selection + tab-local context, §4/§9 [C1]) → identity (backend actor/roles, scoped
// by the selected company) → toast. CompanyProvider blocks rendering its children
// (chooser/empty/error) until a company is installed, so IdentityProvider — mounted beneath it
// — never fires a company-scoped request before selection. The error boundary wraps all so
// provider/render failures are contained.
export function AppProviders({ children }: { children: ReactNode }): JSX.Element {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <CompanyProvider>
            <IdentityProvider>
              <ToastProvider>{children}</ToastProvider>
            </IdentityProvider>
          </CompanyProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
